import { useToggleSurveyPublishMutation } from "../../../../../api/surveys/useToggleSurveyPublishMutation";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { getPathParams } from "../utilities";

export const useTogglePublish = () => {
  const { surveyId } = getPathParams();

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { mutateAsync, isLoading } = useToggleSurveyPublishMutation({
    onSuccess: () => {
      uiNotification.success(t("success.togglePublish"));
    },
    onError: () => {
      uiNotification.error(t("error.togglePublish"));
    },
  });

  return {
    initiate: () => {
      return mutateAsync({ id: surveyId });
    },
    isLoading,
  };
};
